import { useRef, useState } from "react";
import { forbiddenCharacters, getFileNameWithoutFormat } from "../../../../../../scripts/helpers";
import { advancedResponseValidator, post } from "../../../../../../scripts/api";
import { handleSetRenameModalStatus } from "../../../fileManager.actions";
import { syncFileManager } from "../../../fileManager.function";
import API from "../../../../../../urls/api";
import TextInput from "../../../../textInput/textInput.index";
import Button from "../../../../button/button.index";
import { ButtonSize, ButtonType } from "../../../../button/button.interface";
import Dialog from "../../../../dialog/dialog.index";
import { toast } from "mobin-toast";
import { toastMessages } from "../../../../../../scripts/toastMessages";
import { shallowEqual } from "react-redux";
import { useAppSelector } from "../../../../../../redux/hooks";

export default function RenameModal(): JSX.Element {
    const buttonRef = useRef<any>();
    const { selectedResources, renameModalStatus } = useAppSelector(
        ({ fileManager: { selectedResources, renameModalStatus } }) => ({ selectedResources, renameModalStatus }),
        shallowEqual
    );
    const [name, setName] = useState<string>("");
    const [nameError, setNameError] = useState<string>("");

    const handleRename = (new_name?: string) => {
        return new Promise((resolve) => {
            const resource = selectedResources[0];
            if (name.length <= 250) {
                if (!name) {
                    setNameError(".نام را وارد کنید");
                    resolve(true);
                } else if (forbiddenCharacters.some((item) => name.includes(item))) {
                    setNameError(`از حروف غیرمجاز استفاده نکنید! (${forbiddenCharacters.join(" ")})`);
                    resolve(true);
                } else {
                    post(
                        (data, status) => {
                            resolve(true);
                            if (advancedResponseValidator(data, status)) {
                                syncFileManager(false);
                                if (!new_name) {
                                    toast({
                                        title: toastMessages(84),
                                        type: "success",
                                        callbackFunction: () => {
                                            return new Promise((resolve2) => {
                                                handleRename(getFileNameWithoutFormat(resource).name).then(() => resolve2(true));
                                            });
                                        }
                                    });
                                }
                                handleSetRenameModalStatus(false);
                            }
                        },
                        API.fileManager.rename(),
                        {
                            obj_id: selectedResources[0].id,
                            name: new_name
                                ? new_name + getFileNameWithoutFormat(selectedResources[0]).format
                                : name + getFileNameWithoutFormat(selectedResources[0]).format
                        }
                    );
                }
            } else resolve(true);
        });
    };

    return (
        <Dialog title={"تغییر نام"} status={renameModalStatus} onClose={() => handleSetRenameModalStatus(false)}>
            <div
                className="p-4"
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        buttonRef.current.click();
                    } else if (e.key === "Escape") {
                        handleSetRenameModalStatus(false);
                    }
                }}
            >
                <div className="relative">
                    <TextInput
                        label="نام"
                        placeholder=".نام را وارد کنید"
                        onChange={(value) => {
                            if (value.length > 250) setNameError("نام فایل نباید بیشتر از ۲۵۰ کاراکتر باشد!");
                            else setNameError("");
                            setName(value);
                        }}
                        error={nameError}
                        autoFocus={true}
                        value={selectedResources[0] ? getFileNameWithoutFormat(selectedResources[0]).name : ""}
                    />
                    <div className="flex items-center absolute top-1 left-0 font-normal text-[12px]">
                        <div className="!text-[#A0A3BD] !font-bold !text-[10px]">{"250/"}</div>
                        {`${name.length}`}
                    </div>
                </div>
                <div className="flex items-center gap-4 justify-end mt-8">
                    <Button
                        text="انصراف"
                        className="text-secondary-600"
                        size={ButtonSize.SM}
                        type={ButtonType.TEXT}
                        onClick={() => handleSetRenameModalStatus(false)}
                        autoFocus={false}
                    />
                    <Button
                        text="تایید"
                        size={ButtonSize.SM}
                        type={ButtonType.TEXT}
                        onClick={() => handleRename()}
                        ref={buttonRef}
                        autoFocus={false}
                        disable={name.length > 250}
                    />
                </div>
            </div>
        </Dialog>
    );
}
